import { useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

interface TagInputProps {
  tags: string[];
  onTagsChange: (tags: string[]) => void;
}

const TagInput = ({ tags, onTagsChange }: TagInputProps) => {
  const [currentTag, setCurrentTag] = useState("");

  const handleAddTag = () => {
    if (currentTag.trim() && !tags.includes(currentTag.trim())) {
      onTagsChange([...tags, currentTag.trim()]);
      setCurrentTag("");
    }
  };

  const handleRemoveTag = (tagToRemove: string) => {
    onTagsChange(tags.filter(tag => tag !== tagToRemove));
  };

  return (
    <div className="space-y-2">
      <div className="flex gap-2 mb-2">
        <Input
          value={currentTag}
          onChange={(e) => setCurrentTag(e.target.value)}
          placeholder="Add a tag"
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleAddTag();
            }
          }}
        />
        <Button 
          type="button" 
          onClick={handleAddTag} 
          variant="secondary"
        >
          <Plus className="w-4 h-4" />
        </Button>
      </div>
      <div className="flex flex-wrap gap-2">
        {tags.map((tag, index) => (
          <div key={`${tag}-${index}`} className="flex items-center gap-1">
            <Badge variant="secondary">
              {tag}
            </Badge>
            <Button
              type="button"
              variant="ghost"
              size="sm"
              className="h-5 w-5 p-0"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleRemoveTag(tag);
              }}
            >
              <Trash2 className="h-3 w-3 pointer-events-none" />
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TagInput;